import React from 'react';
import SectionShell from '../SectionShell';
import useClickToArmVideo from '../../hooks/useClickToArmVideo';

/**
 * Full-bleed "Black Box" video slide (~5:15).
 *
 * Presenter flow (arm-on-second-click):
 *  • Slide enters viewport → video stays paused
 *  • 1st click → video starts (advance suppressed)
 *  • 2nd click → advance to next slide
 *  • Slide leaves viewport → pause + rewind; arming resets
 */
const VIDEO_SRC = '/videos/black-box.mp4';

export default function SectionBoxVideo() {
  const { videoRef, stageRef } = useClickToArmVideo('box-video');

  return (
    <SectionShell
      id="box-video"
      className="relative overflow-hidden"
      fullBleed
      centerContent
    >
      <div
        ref={stageRef}
        className="zert-video-stage"
        data-testid="box-video-stage"
      >
        <div className="zert-video-frame">
          <video
            ref={videoRef}
            className="zert-video-el"
            playsInline
            controls
            preload="metadata"
            data-testid="box-video"
          >
            <source src={VIDEO_SRC} type="video/mp4" />
          </video>
        </div>
      </div>
    </SectionShell>
  );
}
